import KTextField from "@/components/General/KTextField";

export default {
	name: "KPasswordField",

	extends: KTextField,

	props: {
		hint: String
	},

	data: () => ( {
		capsLockOn: false,
		passwordVisible: false
	} ),

	computed: {
		customAppendIcon() {
			return this.passwordVisible ? "visibility_off" : "visibility";
		},

		customType() {
			return this.passwordVisible ? "text" : "password";
		},

		customHint() {
			if ( this.capsLockOn ) {
				return "WARNING: Caps lock is on";
			}

			return this.hint;
		}
	},

	methods: {
		onAppendIconClick() {
			this.passwordVisible = !this.passwordVisible;
		},

		onInput( e ) {
			this.$emit( "input", e );
		},

		onKeydown( e ) {
			this.capsLockOn = e.getModifierState && e.getModifierState( "CapsLock" );
		}
	},

	render() {
		return <KTextField
			{...{
				attrs: {
					...this.$attrs,
					...this.$props,
					appendIcon: this.customAppendIcon,
					hint: this.customHint,
					type: this.customType
				},
				on: {
					...this.$listeners,
					"click:append": this.onAppendIconClick,
					input: this.onInput,
					keydown: this.onKeydown
				}
			}}
		></KTextField>;
	}
};
